import { render, staticRenderFns } from "./FormFiltroProgramacaoRegiao.vue?vue&type=template&id=7820d10b"
import script from "./FormFiltroProgramacaoRegiao.vue?vue&type=script&lang=js"
export * from "./FormFiltroProgramacaoRegiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports